module.exports = __webpack_public_path__ + "img/gld_gbt75_1985.prt.7194ad76.jpg";